<template>
  <el-container id="app">
    <el-header class="app-header">

      <div style="display: flex; align-items: center;">
        <div style="margin-right:10px">
          <router-link :to="{name: 'Home'}">
            <img alt="Главная" height="25" src="@/assets/img/logo.png"/>
          </router-link>
        </div>


        <menu-component ref="mainMenu"></menu-component>

      </div>
      <div>

        <actions-component></actions-component>

      </div>
    </el-header>
    <el-main v-if="user.id">
      <router-view v-if="user.roles.length" />
      <user-no-role-overlay v-if="!user.roles.length" />
    </el-main>
  </el-container>

</template>

<script>
import {mapGetters} from 'vuex';
import MenuComponent from "@/components/header/MenuComponent.vue";
import ActionsComponent from "@/components/header/ActionsComponent.vue";
import UserNoRoleOverlay from "@/components/user/UserNoRoleOverlay.vue";

export default {
  name: "default-layout",
  components: {UserNoRoleOverlay, ActionsComponent, MenuComponent},

  computed: {
    ...mapGetters(['user']),
    layout() {
      return this.$route.meta.layout || 'default-layout'
    }
  },

  data() {
    return {
      version: process.env.PACKAGE_VERSION,
    }
  },

  created() {
    this.$store.dispatch('fetchUser');
    this.$store.dispatch('settings/loadSettings');
  },

  mounted() {
    // window.addEventListener('resize', function(event) {
    //   console.log("2314234");
    // }, true);
  },
  updated() {
    // this.doMenuSize();
  },
  methods: {
    async doMenuSize(){
      let menuHeight = document.getElementsByClassName("app-header")[0].scrollHeight;

      // Меню в одну строку, все ок
      if( menuHeight < 60 ){
        return;
      }

      const menuItems = document.querySelectorAll(".el-submenu__title,.el-menu-item,.header-actions");
      if( !menuItems.length ){
        return;
      }

      let currentFontSize = parseFloat(window.getComputedStyle(menuItems[0], null).getPropertyValue('font-size'));
      let currentPadding = parseFloat(window.getComputedStyle(menuItems[0], null).getPropertyValue('padding').split(' ')[1]);



      const currentFontSizeLimit = 5;
      const currentPaddingLimit = 5;

      while (menuHeight >= 60 && currentPadding >= currentPaddingLimit && currentFontSize >= currentFontSizeLimit){

        if( currentPadding >= currentPaddingLimit ){
          currentPadding = currentPadding-3;
        }
        if( currentFontSize >= currentFontSizeLimit ){
          currentFontSize--;
        }

        menuItems.forEach(item => {
          item.style.fontSize = currentFontSize + 'px';
          item.style.padding = '0 ' + currentPadding + 'px';
        });

        await this.$nextTick();
        menuHeight = document.getElementsByClassName("app-header")[0].scrollHeight;
      }
    }
  }

}
</script>

<style lang="scss">
@import "@/assets/css/project-variables";


.app-header{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 41px;
  border-bottom: solid 1px #e6e6e6;
  align-items: center;
  background-color: white;
}

.el-avatar > img {
  display: unset;
  height: unset;
  width: 100%;
}

</style>